const MuneezaKassim = () => {
    return(
    <div>
        <div className="bg-[#fcfcfc] pt-[2rem]">
            <div className="sm:max-w-[70rem] mx-auto sm:px-[10rem] lg:flex grid  lg:justify-between items-end">
                <div className="mb-[2.5rem] lg:grid hidden">
                    <h1 className="lg:text-[30px] md:text-[30px] text-[30px] font-bold">Muneeza Kassim</h1>
                    <p>Group Chief Financial Officer</p>
                </div>
                <div className="flex justify-end">
                    <img src="/leadershipnew/muneeza-kassim1.jpg" alt="" className="lg:h-[26rem] h-[17rem] leadership-images mx-[2rem]  leadership-images"/>
                </div>
                <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]"> 
                    <h1 className="sm:text-[30px] text-[26px] font-bold">Muneeza Kassim</h1>
                    <p>Group Chief Financial Officer</p>
                </div>
            </div>
        </div>
        <div className="max-w-[40rem] sm:mx-auto mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-left gap-4">
          <p>
            As a seasoned finance professional, with more than 23 years of experience at Shell & Engro, Muneeza has worked 
            in Pakistan and the UAE at various global regional & local high-level positions within the finance, petrochemical, 
            and terminal Infrastructure.
          </p>
          <p>
            With her strong business acumen, she brought valuable experience to the overall governance, financial 
            controls, and transformation of TCS. Her leadership is based on the care and growth of people. At her last 
            assignment, Muneeza was heading finance optimisation for Engro Corporation and prior to that was the CFO 
            for Engro Vopak Terminal Limited.
          </p>
          
        </div>
    </div>
    );
};
export default MuneezaKassim;